localStorage.setItem('tipe_app', '1');
localStorage.setItem('online', '0');
localStorage.setItem('dev', '0');
localStorage.setItem('versi_app', '2020.B');

if(localStorage.getItem('tipe_app') === '3'){
    localStorage.setItem('root_base', 'android_asset/www/transisi/index.html'); //android
}else if(localStorage.getItem('tipe_app') === '4'){
    localStorage.setItem('root_base', window.location.href); //ios
}else if(localStorage.getItem('tipe_app') === '2'){
    localStorage.setItem('root_base', '/transisi/index.html'); //offline
}else{
    localStorage.setItem('root_base', 'transisi/index.html'); //online
}

// console.log(localStorage.getItem('tipe_app'));
// console.log(localStorage.getItem('root_base'));

console.log(getParameterByName('koneksi'));

switch (Number(localStorage.getItem('online'))) {
    case 1:

        switch (Number(localStorage.getItem('dev'))) {
            case 1:

                localStorage.setItem('api_domain', 'http://pmpoff:1746');
                break;
        
            default:

                switch (getParameterByName('koneksi')) {
                    case 'validasi':
                        
                        localStorage.setItem('api_domain', 'http://118.98.166.82:1746');
                        break;
                        
                    default:
                            localStorage.setItem('api_domain', 'http://118.98.166.82:1746');
                        break;
                }

                break;
        }
        
        // localStorage.setItem('api_domain', 'http://pmp.dikdasmen.kemdikbud.go.id:1746');
        // localStorage.setItem('local_domain', 'http://localhost:3000pmp.dikdasmen.kemdikbud.go.id
        break;
        
    default:
        console.log(window.location.hostname);
        
        // localStorage.setItem('api_domain', 'http://eds.one');
        // localStorage.setItem('api_domain', 'http://localhost:1746');
        localStorage.setItem('api_domain', 'http://'+window.location.hostname+':1746');
        // localStorage.setItem('api_domain', 'http://pmpoff2020:8888');
        // localStorage.setItem('api_domain', 'http://'+window.location.hostname+':1746');
        break;
}
localStorage.setItem('simulasi_hitung',0);
localStorage.setItem('local_domain', 'http://'+window.location.host);
// localStorage.setItem('local_domain', 'http://pmp.dikdasmen.kemdikbud.go.id:1745');

// 
if (localStorage.getItem("jwt_token") === null) {
    localStorage.setItem('jwt_token', '');
}

if (localStorage.getItem("user") === null) {
    localStorage.setItem('user', '');
}

if (localStorage.getItem("aslinya_ops") === null) {
    localStorage.setItem('aslinya_ops', '');
}

if (localStorage.getItem("pengguna_id_ops") === null) {
    localStorage.setItem('pengguna_id_ops', '');
}

// console.log(localStorage.getItem('tahun'));

if (localStorage.getItem("tahun") === null) {
    localStorage.setItem('tahun', '2020');
}

if (localStorage.getItem("instrumen_id") === null) {
    localStorage.setItem('instrumen_id', 'd8be97cd-8eb0-4d70-911d-04610a59e6d3');
}

localStorage.setItem('hitung_aktif', "0");
localStorage.setItem('judul_aplikasi', "EDS 2020 Covid-19");
localStorage.setItem('bos_aplikasi', "Ditjen Paud Dikdas dan Dikmen");
localStorage.setItem('judul_aplikasi_panjang', "Evaluasi Diri Sekolah Dikdasmen");

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


// WEBPACK FOOTER //
// ./src/appConfig.js